/**
 * /frontend/src/features/analytics/hooks/useDateRangeFilter.js
 */

import { useCallback, useMemo, useState } from 'react';
import { DATE_PRESETS } from '../constants/datePresets';

const resolvePreset = (key) => DATE_PRESETS.find((preset) => preset.key === key) || null;

/**
 * Shared date range filter state for analytics pages.
 * @param {string} initialPresetKey
 * @returns {{presetKey:string,startDate:string,endDate:string,setPresetKey:Function,setStartDate:Function,setEndDate:Function,applyPreset:Function}}
 */
const useDateRangeFilter = (initialPresetKey = '7d') => {
  const preset = resolvePreset(initialPresetKey);
  const initial = preset ? preset.resolve() : resolvePreset('7d').resolve();
  const [presetKey, setPresetKey] = useState(initialPresetKey);
  const [startDate, setStartDate] = useState(initial.startDate);
  const [endDate, setEndDate] = useState(initial.endDate);

  const applyPreset = useCallback((key) => {
    const selected = resolvePreset(key);
    if (!selected) {
      setPresetKey('custom');
      return;
    }
    const next = selected.resolve();
    setPresetKey(key);
    setStartDate(next.startDate);
    setEndDate(next.endDate);
  }, []);

  return useMemo(() => ({
    presetKey,
    startDate,
    endDate,
    setPresetKey,
    setStartDate,
    setEndDate,
    applyPreset
  }), [applyPreset, endDate, presetKey, startDate]);
};

export default useDateRangeFilter;

